import BarekamButton, {OrderButtons} from "../../pages/components/button";
import BarekamText from "../../pages/components/text";
import {Message, MessageSections} from "../../pages/components/message/message";
import React from "react";
import {
    GenericActionTypes,
    InWarehouseActionTypes,
    OrderPopupActionTypes,
    ReadyForShipmentActionTypes
} from "./action-types.enum";
import {OrderPopupActionMenuItem} from "./styled";

export const ToolPanelActions = ({actions, onClick}: ToolPanelActionsProps) => {
    if (actions && actions.length) {
        return (
            <>
                {actions.map(action =>
                    <BarekamButton type={OrderButtons.EXPORT} size={"s"}
                                   onClick={() => onClick(action.id)}
                                   key={action.id}>
                        {action.icon}
                        <BarekamText variant={'m'} bold>
                            <Message messageKey={action.name} sectionId={MessageSections.ORDERS}/>
                        </BarekamText>
                    </BarekamButton>
                )}
            </>
        );
    } else {
        return <></>
    }
}

export const ActionBarActions = ({actions, onClick}: ActionBardActionsProps) => {
    if (actions && actions.length) {
        return (
            <>
                {actions.map(action =>
                    <OrderPopupActionMenuItem onClick={() => onClick(action.id)}
                              key={action.id}>
                        {action.icon}

                        <BarekamText variant={"m"}>
                            <Message messageKey={action.name} sectionId={MessageSections.ORDERS}/>
                        </BarekamText>
                    </OrderPopupActionMenuItem>
                )}
            </>
        );
    } else {
        return <></>
    }
}

interface ToolPanelActionsProps {
    actions: {id: InWarehouseActionTypes | ReadyForShipmentActionTypes | OrderPopupActionTypes, name: string, icon: React.ReactElement}[] | undefined,
    onClick: (actionType: InWarehouseActionTypes | ReadyForShipmentActionTypes | OrderPopupActionTypes) => void
}

interface ActionBardActionsProps {
    actions: {id: InWarehouseActionTypes | ReadyForShipmentActionTypes | OrderPopupActionTypes | GenericActionTypes, name: string, icon: React.ReactElement}[],
    onClick: (actionType: InWarehouseActionTypes | ReadyForShipmentActionTypes | OrderPopupActionTypes | GenericActionTypes) => void
}
